import { useParams } from "react-router";


export default function useRouteParams() {
  return useParams();
}
